import { useParams } from "react-router-dom";
import { FiCompass } from "react-icons/fi";
import DetailedSafariTrip from "../components/DetailedSafariTrip";
import SafariList from "../components/SafariList";

const DetailedSafariPage = () => {
  const { id } = useParams();
  const tripId = parseInt(id, 10);

  return (
    <>
      <DetailedSafariTrip tripId={tripId} />

      <section className="bg-[#f6f1e7] pb-20 font-[Poppins]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end">
            <div>
              <div className="mb-4 inline-flex items-center gap-2 border-l-4 border-[#F5B731] bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.22em] text-[#C88804] shadow-sm">
                <FiCompass />
                Related Tours
              </div>
              <h2 className="max-w-3xl text-3xl font-extrabold uppercase leading-tight text-[#082f1f] sm:text-4xl">
                More Safaris You May Like
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-7 text-[#5d7168]">
                Compare similar safari routes, durations, and travel styles for
                your East African journey.
              </p>
            </div>
          </div>

          <SafariList limit={3} excludeId={tripId} />
        </div>
      </section>
    </>
  );
};

export default DetailedSafariPage;
